import {
  Box,
  Button,
  ControlLabel,
  Flex,
  PanelHeader,
  ReactModal,
  Text,
  TextArea,
} from "@coaching-culture/ui";
import { useGoalTerminology } from "auth/OrgProvider";
import { useEffect, useState } from "react";

type ReturnGoalCompletionModalProps = {
  onReturn: (comment: string) => void;
  onCancel: () => void;
  isOpen: boolean;
};

export const ReturnGoalCompletionModal = ({
  onReturn,
  onCancel,
  isOpen,
}: ReturnGoalCompletionModalProps) => {
  const terms = useGoalTerminology();
  const [comment, setComment] = useState("");

  useEffect(() => {
    if (isOpen) {
      setComment("");
    }
  }, [isOpen]);

  return (
    <ReactModal onClose={onCancel} isOpen={isOpen} width={500}>
      <>
        <PanelHeader>
          <Text fontSize="section" fontWeight={600}>
            Return this {terms.goal.asBody()}?
          </Text>
        </PanelHeader>
        <Box p={3}>
          <Text mb={3}>
            The {terms.goal.asBody()} will go back to In Progress and its owner
            will be notified.
          </Text>
          <ControlLabel>Reason (optional)</ControlLabel>
          <TextArea
            rows={4}
            value={comment}
            onChange={(ev) => setComment(ev.target.value)}
            placeholder="Explain what still needs to happen"
          />
          <Flex mt={3} justifyContent={"flex-end"}>
            <Button type="button" onClick={onCancel} mr={2}>
              Cancel
            </Button>
            <Button color="primary" onClick={() => onReturn(comment)}>
              Return {terms.goal.asTitle()}
            </Button>
          </Flex>
        </Box>
      </>
    </ReactModal>
  );
};
